import * as React from 'react';
import { ChangeImageDialogModel } from './model/ProfileSettingsModel';
import { ProfileSettingsController } from './controller/ProfileSettingsController';
import { Dialog } from 'components/dialog';
import { Button } from '@material-ui/core';

export class ChangeImageDialog extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);

        this.state = { fileName: null, imageBase64: null };

        this.handleFileChange = this.handleFileChange.bind(this);
        this.handleCancelButtonClicked = this.handleCancelButtonClicked.bind(this);
        this.handleSaveButtonClicked = this.handleSaveButtonClicked.bind(this);
    }

    private handleFileChange(event: React.ChangeEvent<HTMLInputElement>) {
        var files = event.target.files;
        if (files == null || files.length < 1) {
            this.setState({ fileName: null, imageBase64: null });
            return;
        }
        var file = files[0];
        var reader = new FileReader();
        reader.onload = () => {
            var result = reader.result as string;
            // result is a data URL: "data:image/jpeg;base64,....."; keep only the base64 part.
            var commaIndex = result.indexOf(",");
            var base64 = commaIndex >= 0 ? result.substring(commaIndex + 1) : result;
            this.setState({ fileName: file.name, imageBase64: base64 });
        };
        reader.readAsDataURL(file);
    }

    private handleCancelButtonClicked() {
        this.props.controller.onChangeImageCancelClicked();
    }

    private handleSaveButtonClicked() {
        if (this.state.imageBase64 == null) {
            return;
        }
        this.props.controller.onChangeImageSaveClicked(this.state.imageBase64);
    }

    public render() {
        return (
            <Dialog title="Change profile picture" desc="Choose a file to change your profile picture!" error={this.props.model.imageError}>
                <div style={{ width: '100%', marginBottom: '24px' }}>
                    <input type="file" accept=".jpg,.jpeg,image/jpeg" onChange={this.handleFileChange} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
                    <Button color="secondary" onClick={this.handleCancelButtonClicked}>Cancel</Button>
                    <Button style={{ marginLeft: '8px' }} color="primary" variant="contained" disabled={this.state.imageBase64 == null} onClick={this.handleSaveButtonClicked}>Save</Button>
                </div>
            </Dialog>
        );
    }

}

export interface Props {

    model: ChangeImageDialogModel;
    controller: ProfileSettingsController;

}

interface State {

    fileName: string;
    imageBase64: string;

}
